// extracted by mini-css-extract-plugin
export default {"bet":"_2pN2P","betLabel":"_2m0Mu","increased":"_1vPEO","increase":"_1SLzS","decreased":"_35NYx","decrease":"_3r9zO"};